import template from './wizard_employee_fields.html';

class WizardEmployeeFieldsViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	};

	back_wizard()
	{
		Grape.dialog.open('WizardDepartmentsEntry', {});
		this.dialog.close();
	};

	next_wizard()
	{
		Grape.dialog.open('WizardHolidayEntry', {});
		this.dialog.close()
	};
};

class WizardEmployeeFieldsPage
{
	constructor (bindings)
	{
		this.viewModel = new WizardEmployeeFieldsViewModel(this);
		this.bindings = bindings;
	}
};

export default {
	name: 'WizardEmployeeFieldsEntry',
	dialog_class: WizardEmployeeFieldsPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_employee_fields',
	provider: 'ps'
};
